import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Tab,
  Nav,
  Button,
  Table,
  Spinner,
  Modal
} from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AdminMessagesList = () => {
  const [allMessages, setAllMessages] = useState([]);
  const [personalMessages, setPersonalMessages] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [loading, setLoading] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const { t } = useTranslation();


  const fetchMessages = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await axios.get("/api/admin/all-messages", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const all = res.data.filter((msg) => msg.is_global);
      const personal = res.data.filter((msg) => !msg.is_global);

      setAllMessages(all);
      setPersonalMessages(personal);
    } catch (err) {
      console.error("Помилка при завантаженні повідомлень", err);
    } finally {
      setLoading(false);
    }
  };

  const deleteMessage = async (id) => {
    if (!window.confirm("Видалити повідомлення?")) return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/api/delete-message/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchMessages();
    } catch (err) {
      console.error("Помилка при видаленні", err);
    }
  };

  const handleView = (msg) => {
    setSelectedMessage(msg);
    setShowModal(true);
  };

  const handleClose = () => {
    setSelectedMessage(null);
    setShowModal(false);
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  const renderTable = (data, showRecipients = false) => {
    const totalPages = Math.ceil(data.length / itemsPerPage);
    const paginated = data.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

    return (

      <>

        <Table bordered hover responsive>
          <thead className="table-light text-center">
            <tr>
              <th >ID</th>
              <th>{t("messageTitle")}</th>
              <th>{t("importance")}</th>
              <th>{t("createdAt")}</th>
              {showRecipients && <th>{t("deliveryStatus")}</th>}
              <th>{t("actions")}</th>
            </tr>
          </thead>

          <tbody>
            {paginated.map((msg) => (
              <tr key={msg.id}>
                <td>{msg.id}</td>
                <td dangerouslySetInnerHTML={{ __html: msg.title }} />
                <td>{msg.importance}</td>
                <td>{new Date(msg.created_at).toLocaleString()}</td>

                {showRecipients && (
                  <td>
                    {msg.recipients?.length > 0 ? (
                      msg.recipients.map((r, i) => (
                        <div key={i}>
                          {r.firstName} {r.lastName} —{" "}
                          {r.read_at ? (
                            <span className="text-success">✅ {t("read")}</span>
                          ) : r.opened_at ? (
                            <span className="text-warning">📖 {t("opened")}</span>
                          ) : (
                            <span className="text-muted">❌ {t("notDelivered")}</span>
                          )}
                        </div>
                      ))
                    ) : (
                      "-"
                    )}
                  </td>
                )}

                <td>
                  <Button
                    variant="secondary"
                    size="sm"
                    className="me-2"
                    onClick={() => handleView(msg)}
                  >
                    {t("view")}
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => deleteMessage(msg.id)}
                  >
                    {t("delete")}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            <nav>
              <ul className="pagination">
                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    <button className="page-link">{i + 1}</button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>{t("messages")}</h4>
        <Button href="/admin/messages" variant="primary">
          ➕ {t("createMessage")}
        </Button>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : (
        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Nav variant="tabs" className="mb-3">
            <Nav.Item>
              <Nav.Link eventKey="all">Повідомлення для всіх</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="personal">Особисті повідомлення</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="all">{renderTable(allMessages)}</Tab.Pane>
            <Tab.Pane eventKey="personal">{renderTable(personalMessages, true)}</Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      )}

      {/* Модальне вікно */}
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedMessage?.title || t("message")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMessage?.content && (
            <div
              dangerouslySetInnerHTML={{ __html: selectedMessage.content }}
              className="mb-3"
            />
          )}

          {selectedMessage?.is_global && selectedMessage?.reads && (
            <>
              <h6>{t("deliveryStatus")}</h6>

              <ul>
                {selectedMessage.reads.map((r, i) => (
                  <li key={i}>
                    {r.firstName} {r.lastName} —{" "}
                    {r.read_at ? (
                      <span className="text-success">✅ {t("read")}</span>
                    ) : r.opened_at ? (
                      <span className="text-warning">📖 {t("opened")}</span>
                    ) : (
                      <span className="text-muted">❌ {t("notDelivered")}</span>
                    )}
                  </li>
                ))}
              </ul>
            </>
          )}

          {!selectedMessage?.is_global &&
            selectedMessage?.recipients?.length > 0 && (
              <>
                <h6>{t("recipients")}</h6>
                <ul>
                  {selectedMessage.recipients.map((r, i) => (
                    <li key={i}>
                      {r.firstName} {r.lastName} —{" "}
                      {r.read_at ? (
                        <span className="text-success">✅ {t("read")}</span>
                      ) : r.opened_at ? (
                        <span className="text-warning">📖 {t("opened")}</span>
                      ) : (
                        <span className="text-muted">❌ {t("notDelivered")}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </>
            )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("close")}

          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminMessagesList;
